import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, Modal, Badge } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import { ModalProps } from 'antd/lib/modal';

import { UserTaskSummariesDataService } from 'src/app/general/user-tasks/list/user-task-list.data';
import { AddUserTaskView } from 'src/app/general/user-tasks/parts/add-user-tasks.view';
import { observable } from 'mobx';
import { resolve } from 'inversify-react';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';
import { ZuluIcon } from 'src/app/shared/icon';

interface Props {
	modelType?: string;
	modelId?: any;
	setBusy(isBusy: boolean);
	kanban?: boolean;
	extraFilter?: (dataService: UserTaskSummariesDataService) => void;
	buttonProps?: ButtonProps;
	buttonText?: string | null;
	modalProps?: ModalProps;
	count?: number;
	state: number;
	daedline: Date;
	assignedToId: number;
	priority: number;
	titleTask: string;
	useLoginFilter: boolean
}

interface State {
	modalOpen: boolean;
	userTaskCount: number;
}

@observer
export class UserTasksModalView extends React.Component<Props, State> {
	_isMounted: boolean;
	constructor(props: Readonly<Props>) {
		super(props);
		this.state = {
			modalOpen: false,
			userTaskCount: 0
		}
	}
	componentWillUnmount() {
		this._isMounted = false;
	}
	onCancel = () => {
		this.handleModal();
	}

	handleModal = () => {
		this.setState({ modalOpen: !this.state.modalOpen });
	}

	@resolve
	contextService: ContextService;

	@resolve
	formatService: FormatService;

	@observable
	userTaskDataService: UserTaskSummariesDataService;

	public componentDidMount() {
		this._isMounted = true;
		this.userTaskDataService = UserTaskSummariesDataService.make(this.contextService, this.formatService);

		this.userTaskDataService.addSorting('priority', 'asc', true);
		this.userTaskDataService.addFilter('isDeleted', 'eq', false);

		this.userTaskDataService.addFilter('modelType', 'eq', this.props.modelType)
		this.userTaskDataService.addFilter('modelId', 'eq', this.props.modelId)
		this.userTaskDataService.params = {};
		this.userTaskDataService.params["useLoginFilter"] = this.props.useLoginFilter;
		// fetch data if model state is unchanged or changed
		if (this.props.state === 10 || this.props.state === 30) {
			this.userTaskDataService.load(query => query).then(result => {
				if (this._isMounted) {
					this.setState({ userTaskCount: this.userTaskDataService.items.length });
				}
			});
		}
	}

	public render() {
		const { buttonProps, buttonText, modalProps } = this.props;
		let text = buttonText;
		if (text === undefined) {
			text = "User tasks";
		}

		return (
			<React.Fragment>
				<Modal
					{...modalProps}
					width={900}
					visible={this.state.modalOpen}
					title='User tasks'
					onCancel={this.handleModal}
					onOk={this.handleModal}
				>
					<AddUserTaskView
						title=''
						useLoginFilter={this.props.useLoginFilter}
						onLoad={data => this.setState({ userTaskCount: data.length })}
						{...this.props}
					/>
				</Modal>
				<Button {...buttonProps as any} icon={undefined} onClick={this.handleModal} className="top-1">
					<Badge  style={{ right: '-10px', marginTop: '0px' }}count={this.state.userTaskCount}>
						{buttonProps.icon && <ZuluIcon type={buttonProps.icon} />}
						{text}
					</Badge>
				</Button>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/user-tasks-modal.tsx